/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Blockly from 'blockly/core';
import FieldDate from "@blockly/field-date";

// constructor for custom field 
let CustomFieldDate = function (opt_value, opt_validator, opt_textEdit) {
    CustomFieldDate.superClass_.constructor.call(this, opt_value, opt_validator, opt_textEdit);

    // saves old functions we will overwrite
    this.originalDropdownCreate = FieldDate.prototype.dropdownCreate_;
}

// tells blockly we are extending the FieldDate
Blockly.utils.object.inherits(CustomFieldDate, FieldDate);

// creates original datepicker which we still need
CustomFieldDate.prototype.dropdownCreate_ = function() {
    this.picker_ = this.originalDropdownCreate();
    this.picker_.setUseSimpleNavigationMenu(false);
    return this.picker_;
}

CustomFieldDate.prototype.applyColour = function() {
    this.todayColour_ = 'rgba(0, 0, 0, 0.88)';
    this.selectedColour_ = '#00FFEB';
    this.updateEditor_();
};

export { CustomFieldDate }
